<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-freezing-rain`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M36.556 16.122C34.8 8.602 28.055 3 20 3 10.611 3 3 10.611 3 20c0 6.497 3.644 12.142 9 15.004v-4.756C8.956 27.868 7 24.163 7 20c0-7.18 5.82-13 13-13s13 5.82 13 13h2l.225.004A6 6 0 0138 31.197v4.345C42.058 34.267 45 30.477 45 26c0-4.994-3.66-9.133-8.444-9.878zM20 33a3 3 0 10-6 0 3 3 0 006 0zm15.366-1.562l-1.732-1a1 1 0 00-1.366.366l-6.5 11.258a1 1 0 00.366 1.366l1.732 1a1 1 0 001.366-.366l6.5-11.258a1 1 0 00-.366-1.366zM20 41a3 3 0 10-6 0 3 3 0 006 0zM9 38a3 3 0 110 6 3 3 0 010-6zm16-8a3 3 0 110 6 3 3 0 010-6z"/></svg>
</template>
<script>

export default {
  name: 'IconFreezingRain',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
